import { Head } from "@inertiajs/react"
import PublicLayout from "@/components/PublicLayout"

export default function PrivacyPolicy() {
  return (
    <>
      <Head title="Privacy Policy — Sanctuary Therapy Centre">
        <meta
          name="description"
          content="Privacy policy for Sanctuary Therapy Centre — how we collect, use, and protect your personal information."
        />
        <meta property="og:title" content="Privacy Policy — Sanctuary Therapy Centre" />
        <meta
          property="og:description"
          content="How Sanctuary Therapy Centre collects, uses, and protects your personal information."
        />
      </Head>
      <PublicLayout>
        <section className="bg-stone pt-32 pb-14">
          <div className="mx-auto max-w-3xl px-6 lg:px-8">
            <h1>Privacy Policy</h1>
            <p className="mt-2 text-sm text-ink-muted">Last updated: June 2026</p>
          </div>
        </section>

        <section className="bg-cream py-14">
          <div className="mx-auto max-w-3xl px-6 lg:px-8 body-content">
            <p>
              This privacy policy sets out how Sanctuary Therapy Centre ("we", "us", "our") collects
              and uses personal information when you visit our website or contact us.
            </p>

            <h2>What information we collect</h2>
            <p>
              When you submit an enquiry through our contact form, we collect your name, email
              address, phone number (if provided), and the content of your message. We also collect
              basic analytics data such as the pages you visit on our site.
            </p>

            <h2>How we use your information</h2>
            <p>We use the information you provide to:</p>
            <ul>
              <li>Respond to your enquiry or booking request</li>
              <li>Improve our website and services</li>
              <li>Comply with our legal obligations</li>
            </ul>

            <h2>Data storage and security</h2>
            <p>
              Your personal data is stored securely on servers located within the UK/EU. We take
              appropriate technical and organisational measures to protect your information against
              unauthorised access, loss, or destruction.
            </p>

            <h2>Third parties</h2>
            <p>
              We do not sell or share your personal data with third parties for marketing purposes.
              We may share data with service providers who assist us in operating our website (such
              as email service providers), subject to appropriate data processing agreements.
            </p>

            <h2>Your rights</h2>
            <p>
              Under GDPR and UK data protection law, you have the right to access, rectify, or
              delete the personal data we hold about you. To exercise any of these rights, please
              contact us at{" "}
              <a href="mailto:hello@sanctuarytherapycentre.co.uk">
                hello@sanctuarytherapycentre.co.uk
              </a>
              .
            </p>

            <h2>Cookies</h2>
            <p>
              Our website uses cookies to improve your experience. Essential cookies are required
              for the website to function. By continuing to use our site you consent to our use
              of cookies.
            </p>

            <h2>Changes to this policy</h2>
            <p>
              We may update this privacy policy from time to time. The most recent version will
              always be available on this page.
            </p>

            <h2>Contact us</h2>
            <p>
              If you have any questions about this privacy policy, please contact us at{" "}
              <a href="mailto:hello@sanctuarytherapycentre.co.uk">
                hello@sanctuarytherapycentre.co.uk
              </a>
              .
            </p>
          </div>
        </section>
      </PublicLayout>
    </>
  )
}
